<template>
    <div class="bottom-list-wrap" >
        <div v-if="single_data">
            <div class="main-title">
                <h1 v-html="single_data.brand_text1"></h1>
                <h1 v-html="single_data.brand_text2"></h1>
                
                    <div class="duration">
                        <span>活動期間</span>
                        <span>{{single_data.duration}}</span>
                    </div>
                </div>
                <div class="product-list">
                    <ul>
                        <li class="product-title">
                            <span class="p-name">品名</span>
                            <span class="p-code">條碼</span>
                        </li>
                    </ul>
                    <div class="custom-scroller-wrap">
                        <ul class="custom-scroller" v-if="show" style="opacity:0;">
                            <li class="product" v-for="data in single_data.products">
                                <span class="p-name">{{data.p_name}}</span>
                                <span class="p-code">{{data.p_code}}</span>
                            </li>
                        </ul>
                    </div>
                    <!-- <ul class="test"  style="height: 40vh;" v-else>
                        holder

                    </ul> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            show: true,
            //single_data: ""
        }
    },
    props: ['single_data'],
    methods: {
        ct_scroll(){
            $(".custom-scroller").mCustomScrollbar({
                theme: "rounded-dots",
                mouseWheelPixels: 80,
                scrollInertia: 0
            });

        }
    },
    watch: {
        '$route' (to, from) {
            this.show = false;
            setTimeout(()=>{
                this.show = true;
                $(".custom-scroller").css("opacity", "0");
            }, 1);
            setTimeout(()=>{ 
                this.ct_scroll()
                $(".custom-scroller").css("opacity", "1");
            },100);

        },
        windowWidth(new_w, old_w) {
        //this.slick_list_click();
        }
    },
    created(){
        setTimeout(()=>{
            $(".custom-scroller").css("opacity", "1"); 
            this.ct_scroll();
        },400);
    },
    mounted(){
    }
}



</script>
<style lang="sass">
.custom-scroller-wrap
    height: 40vh
.custom-scroller
    transition: .3s
</style>



// WEBPACK FOOTER //
// src/FlowerList/list.vue